import styled from 'styled-components';
import Theme from '../../theme';
import { Caption } from '../Base';

const Ribbon = styled(Caption)`
  color: ${Theme.colours.primary};
`;

export default Ribbon;
